import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {TermCondition} from '../../../global/util/TermCondition';
import {Constant} from '../../../global/util/Constant';
import {TermPdfViewerComponent} from '../../../shared/term-pdf-viewer/term-pdf-viewer.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';
import {PublicService} from '../../../user/service/public.service';

@Component({
    selector: 'app-accept-term-condition-onesign',
    templateUrl: './accept-term-condition-onesign.component.html',
    styleUrls: ['./accept-term-condition-onesign.component.css']
})
export class AcceptTermConditionOnesignComponent implements OnInit {
    public iamNotRobotChecked = false;
    public termConditionChecked = false;
    public acceptRequestChecked = false;
    public requestId: boolean;
    public signCompleted = false;
    public document: any;
    public errorMessage = '';
    public hashIdentifier: string;
    public person: any;
    public personId: any;

    constructor(public translate: TranslateService,
                private route: Router,
                private activatedRoute: ActivatedRoute,
                private publicService: PublicService,
                private modalService: NgbModal) {
        this.receiveParams();
    }

    ngOnInit(): void {
        if (LocalStorage.getItem('termConditionAccepted') === 'true') {
            this.iamNotRobotChecked = true;
            this.termConditionChecked = true;
            this.acceptRequestChecked = true;
        }
    }


    /**
     * Registramos los terminos y condicones aceptadas por el cliente.
     * @param document
     * @param typeSignature
     */
    registerAcceptTerm() {
        this.publicService.register(this.document._more.uanatacaRequestId).subscribe((next: any) => {
            LocalStorage.setItem('termConditionAccepted', 'true');
        }, error => {
            Dialog.show(InformType.Danger, 'Términos y condiciones', this.translate.instant('MESSAGE.ERROR-REGISTER-TERMS-AND-CONDITIONS'));
        });
    }

    public receiveParams() {
        this.activatedRoute.params.subscribe(params => {
            this.hashIdentifier = params.hashIdentifier;
            this.personId = +params.personId;
        });
        this.document = history.state.document;
        this.person = history.state.person;
    }

    public resolved(captchaResponse: string): void {
        if (captchaResponse) {
            this.iamNotRobotChecked = true;
        } else {
            this.iamNotRobotChecked = false;
        }
    }

    public onError(errorDetails: any): void {
        this.iamNotRobotChecked = false;
    }

    accept() {
        if (this.iamNotRobotChecked && this.termConditionChecked && this.acceptRequestChecked) {
            this.registerAcceptTerm();
            this.navigateRequestCodeOTP();
        } else {
            this.errorMessage = this.translate.instant('MESSAGE.RECAPTCHA-IMPORTANT-MESSAGE');
        }
    }

    checked(event: any) {
        this.termConditionChecked = event.target.checked;
    }


    checked2(event: any) {
        this.acceptRequestChecked = event.target.checked;
    }

    openModalPdfViewer4termAndConditions() {
        const url = TermCondition.PATH_FILE.concat('term-and-conditions.pdf');
        const tittle = this.translate.instant('TITLE.TERMS-AND-CONDITIONS');
        this.openModalPdfViewer(url, tittle);
    }

    openModalPdfViewer4CertificateRequest() {
        const url = Constant.ROOT_API_V1.concat('/public/solcert/requests/')
            .concat(String(this.document._more.solcertRequestId));
        const tittle = this.translate.instant('TITLE.CERTIFICATE-REQUEST');
        this.openModalPdfViewer(url, tittle);
    }

    openModalPdfViewer(url: string, tittle: string) {
        const opemModal = this.modalService.open(TermPdfViewerComponent, {
            backdrop: 'static',
            size: 'lg'
        });
        opemModal.componentInstance.urlStream = url;
        opemModal.componentInstance.title = tittle;
    }

    get hasConfigDragRubric(): boolean {
        return !this.isCloseStampingAndIsNotDigitalSignature && !this.signCompleted && this.hasConfigRubric && this.hasDragRubric;
    }

    get isCloseStampingAndIsNotDigitalSignature(): boolean {
        if (this.document !== undefined) {
            return this.document.closedStamping;
        }
    }

    get hasConfigRubric(): boolean {
        if (this.document !== undefined) {
            return this.document._more.hasRubricSettings;
        }
    }

    get hasDragRubric(): boolean {
        return this.document._more.dragRubric;
    }

    goBack() {
        this.hasConfigRubric ? this.navigateDragDropRubric() : this.navigateNextScreen(this.hashIdentifier, this.personId, 'viewer');
    }

    private navigateDragDropRubric() {
        this.navigateNextScreen(this.hashIdentifier, this.personId, 'add-or-draw-rubric');
    }

    private navigateRequestCodeOTP() {
        this.navigateNextScreen(this.hashIdentifier, this.personId, 'request-otp-code');
    }

    /**
     * Este método recibe paramatros para navegar entre pantallas.
     * @param hashIdentifier :
     * @param personId :
     * @param nameUrl :
     * @private
     */
    private navigateNextScreen(hashIdentifier: any, personId: any, nameUrl: any) {
        this.route.navigate(['document/' + hashIdentifier + '/people/' + personId + '/' + nameUrl + '/'], {
            state: {
                document: this.document,
                person: this.person
            }
        }).then();
    }
}
